import React, { lazy, useEffect, useState } from 'react'

interface DisplayIcon {
  iconName: string
  inverse?: boolean
  classes?: string
  color?: string
}

const DisplayIcon = ({
  iconName,
  inverse = false,
  color,
  classes
}: DisplayIcon) => {
  const [ImportedIcon, setImportedIcon] = useState(null)

  useEffect(() => {
    const Icon =
      iconName.length && iconName !== 'none'
        ? lazy(
            () =>
              import(
                /* webpackChunkName: "displayicon-[request]" */
                `@toasttab/shared/src/components/atoms/DisplayIcon/Icons/${iconName}.tsx`
              )
          )
        : ''
    setImportedIcon(Icon)
  }, [iconName])

  return ImportedIcon ? (
    <ImportedIcon classes={classes} color={color} inverse={inverse} />
  ) : null
}

export default DisplayIcon
